import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
});

export default validationSchema;